import React from "react";
import { Stack, Typography } from "@mui/material";

export const DisplayPoints = ({
  points,
  title,
  className = "",
}: {
  title: string;
  points: number;
  className?: string;
}) => (
  <Stack direction="column" gap="10px" data-testid="tiers-point-progress" className={className}>
    <Typography variant="body1" style={{ opacity: "70%" }}>
      {title}
    </Typography>
    <Typography variant="h2" style={{ fontSize: "32px", marginBottom: "0" }}>
      {points}
    </Typography>
  </Stack>
);
